import { repositories } from '../repositories';
import type { AICall, AICallStats } from '../repositories/AICallRepository';

/**
 * Service for AI call operations
 */
export class AICallService {
  /**
   * Get all AI calls
   */
  async getAllCalls(): Promise<AICall[]> {
    return await repositories.aiCalls.findAll();
  }

  /**
   * Get all calls with stats data
   */
  async getAllCallsWithStats(): Promise<Partial<AICall>[]> {
    return await repositories.aiCalls.getAllCallsWithStats();
  }

  /**
   * Get recent calls with company information
   */
  async getRecentCallsWithCompany(limit: number = 10): Promise<any[]> {
    return await repositories.aiCalls.getRecentCallsWithCompany(limit);
  }

  /**
   * Get call statistics
   */
  async getCallStats(): Promise<AICallStats> {
    return await repositories.aiCalls.getCallStats();
  }

  /**
   * Get call by ID
   */
  async getCallById(id: string): Promise<AICall | null> {
    return await repositories.aiCalls.findById(id);
  }

  /**
   * Get calls by status
   */
  async getCallsByStatus(status: AICall['status']): Promise<AICall[]> {
    return await repositories.aiCalls.getCallsByStatus(status);
  }

  /**
   * Create new call record
   */
  async createCall(data: Partial<AICall>): Promise<AICall> {
    return await repositories.aiCalls.create(data);
  }

  /**
   * Update call
   */
  async updateCall(id: string, data: Partial<AICall>): Promise<AICall> {
    return await repositories.aiCalls.update(id, data);
  }

  /**
   * Delete call
   */
  async deleteCall(id: string): Promise<void> {
    await repositories.aiCalls.delete(id);
  }
}

// Export singleton instance
export const aiCallService = new AICallService();
